import { initFacebookSdk } from "./init-facebook-sdk";

export function initFacebook(facebookAppId: string|undefined): Promise<any> {
  if (facebookAppId === undefined) {
    return Promise.reject("No Facebook app id specified");
  }

  return initFacebookSdk(facebookAppId);
}
